interface Props {
  children?: React.ReactNode;
}

export const TableDataLeft: React.FC<Props> = ({ children }) => {
  return (
    <td className="whitespace-nowrap text-left px-1 pt-1 pb-2 text-xs font-normal align-top text-gray-900">
      {children}
    </td>
  );
};
